import { TargitDashboard } from 'ui/components';

export const TargitDashboardFeature: React.FC<Content.TargitDashboard> = ({ content }) => {
    const { targitItems } = content?.properties ?? {};
    
    return (
        <TargitDashboard
            targitItems={targitItems.map(({ content }) => {
                const { dashboardTitle, dashboardUrl } = content?.properties ?? {};
                
                return {
                    dashboardTitle,
                    dashboardUrl
                };
            })}
        />
    );
};
